import { Customer } from 'types/DeviceActivity'
import { useState, useEffect } from 'react'

import Api from 'services/api'

const useRecentCustomerActivity = (dealerId: string) => {
  const [recentActivities, setRecentActivities] = useState<Customer[]>([])
  const [areRecentCustomerActivityLoaded, setRecentCustomerActivityLoaded] = useState(false)

  useEffect(() => {
    Api.RecentDeviceActivity.get(dealerId)
      .then((res) => {
        setRecentActivities(res)
      }).catch(() => {
        setRecentActivities([])
      }).finally(() => {
        setRecentCustomerActivityLoaded(true)
      })
  }, [dealerId])

  return { recentActivities, areRecentCustomerActivityLoaded }
}

export default useRecentCustomerActivity
